/** `7h 54m`: hours and minutes with leftover seconds dropped; a dash when there is nothing to average. */
export function formatAverage(totalSeconds: number | null): string {
  if (totalSeconds === null) {
    return '—';
  }
  const safe = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  return `${hours}h ${minutes}m`;
}
